import { NavLink } from 'react-router-dom';
import { cn } from '../utils/cn';

// =============================================================================
// SubTabs — top sub-navigation strip for a top-level section landing (W5 IA).
//
// 각 최상위 메뉴(미디어/디바이스/어드민/BO)는 그룹 랜딩 + 서브탭으로 구성된다.
// 기존 페이지 컴포넌트를 라우트 경로만 재배치해 서브탭 아래에 렌더한다.
// =============================================================================

export type SubTab = { to: string; label: string; sub?: string; end?: boolean };

export function SubTabs({ tabs, className }: { tabs: SubTab[]; className?: string }): JSX.Element {
  return (
    <nav className={cn('flex flex-none items-center gap-1 border-b border-line bg-panel px-4 py-2', className)}>
      {tabs.map((t) => (
        <NavLink
          key={t.to}
          to={t.to}
          end={t.end ?? false}
          className={({ isActive }) =>
            cn(
              'inline-flex items-center gap-1.5 rounded px-3 py-1.5 text-[15px] transition-colors duration-fast',
              isActive
                ? 'bg-accent-soft text-accent border border-accent-ring'
                : 'border border-transparent text-text-dim hover:bg-panel-hover hover:text-text',
            )
          }
        >
          <span className="font-medium">{t.label}</span>
          {t.sub && <span className="text-[12px] opacity-70">{t.sub}</span>}
        </NavLink>
      ))}
    </nav>
  );
}
